import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Spin, Row, Col, DatePicker } from "antd";
import { getDashboardApi } from "mock/dashboardDemoData";
import moment from "moment";

const PeriodicalStatus = () => {

    const [periodicalStatusData, setPeriodicalStatusData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState(moment());
    const clientId = localStorage.getItem("client_id");

    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            if (isMounted) setIsLoading(true);
            try {
                const dateParam = selectedDate.format('YYYY-MM');
                const { error, result } = await getDashboardApi(`/client_periodical_count?client_id=${clientId}&date=${dateParam}`);
                if (!error && isMounted) {
                    setPeriodicalStatusData({ result: result.result || {} });
                } else if (isMounted) {
                    setPeriodicalStatusData({ result: { status_counts: [], total_count: 0 } });
                }
            } catch (err) {
                console.error('Error fetching periodical status:', err);
                if (isMounted) {
                    setPeriodicalStatusData({ result: { status_counts: [], total_count: 0 } });
                }
            } finally {
                if (isMounted) setIsLoading(false);
            }
        };

        if (clientId) {
            fetchData();
        } else {
            setIsLoading(false);
        }

        return () => {
            isMounted = false;
        };
    }, [clientId, selectedDate]);

    const handleDateChange = (date) => {
        if (date) {
            setSelectedDate(date);
        }
    };

    const scheduledPeriodicals = periodicalStatusData?.result?.status_counts?.find((elem) => elem?.status_id == 1) || { count: 0 };
    const completedPeriodicals = periodicalStatusData?.result?.status_counts?.find((elem) => elem?.status_id == 5) || { count: 0 };
    const overduePeriodicals  = periodicalStatusData?.result?.status_counts?.find((elem) => elem?.status_id == 6) || { count: 0 };
    const inProgressPeriodicals = periodicalStatusData?.result?.status_counts?.find((elem) => elem?.status_id == 3) || { count: 0 };
    const assignedPeriodicals = periodicalStatusData?.result?.status_counts?.find((elem) => elem?.status_id == 2) || { count: 0 };
    const totalPeriodicals = periodicalStatusData?.result?.total_count || 0;

    const scheduledTasks = scheduledPeriodicals.count + assignedPeriodicals.count + inProgressPeriodicals.count;
    const completedTasks = completedPeriodicals.count;
    const missedTasks = overduePeriodicals.count;

    const chartOptions = {
        chart: { type: "donut" },
        labels: ["Scheduled", "Completed"],
        colors: ["#2F6FE0", "#1A8F5C"], // Scheduled, Completed: same as the legend squares (index.css)
        legend: { show: false },
        dataLabels: { enabled: false },
        plotOptions: {
            pie: {
                donut: {
                    size: "70%",
                    labels: {
                        show: true,
                        name: { show: false },
                        value: {
                            show: true,
                            fontSize: "24px",
                            fontWeight: 700,
                            color: "#101828",
                            formatter: () => totalPeriodicals,
                        },
                        total: {
                            show: true,
                            label: "",
                            fontSize: "24px",
                            fontWeight: 700,
                            color: "#101828",
                            formatter: () => totalPeriodicals,
                        },
                    },
                },
            },
        },
        stroke: { width: 0 },
    };

    const seriesData = [scheduledTasks, completedTasks];

    return (
        <div className="audit-status-container">
            <div className="audit-status-header">
                <h3>Periodicals & Work Scheduler</h3>
                <p>Monthly view</p>
                <DatePicker
                    picker="month"
                    value={selectedDate}
                    onChange={handleDateChange}
                    format="MM-YYYY"
                    placeholder="Select Month"
                    style={{ width: 120, fontSize: '12px' }}
                    allowClear={false}
                    // disabledDate={(current) => current && current > moment().endOf('month')}
                    size="small"
                />
            </div>

            {isLoading ? (
                <div style={{ height: "200px", width: "100%" }} className="d-flex justify-content-center align-items-center">
                    <Spin />
                </div>
            ) : (
                <>
                    {/* Row 1: Chart and Legend */}
                    <Row gutter={20} className="audit-chart-row" align="middle">
                        <Col span={12}>
                            <div className="audit-chart-container">
                                <ReactApexChart
                                    options={chartOptions}
                                    series={seriesData}
                                    type="donut"
                                    width="140"
                                    height={140}
                                />
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className="audit-legend">
                                <div className="legend-item">
                                    <div className="legend-color periodical-scheduled"></div>
                                    <span>Scheduled</span>
                                </div>
                                <div className="legend-item">
                                    <div className="legend-color audit-completed"></div>
                                    <span>Completed</span>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Row 2: Stats */}
                    <Row gutter={20} className="audit-stats-row">
                        <Col span={12}>
                            <div className="stat-item">
                                <div className="stat-label">Scheduled</div>
                                <div className="stat-value">{scheduledTasks}</div>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className="stat-item">
                                <div className="stat-label">Completed</div>
                                <div className="stat-value">{completedTasks}</div>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
        </div>
    );
};

export default PeriodicalStatus;
